export const sendRatingAPI = "/feedback";
export const getFAQsTagsAPI = "/faqs/categories";
export const getFAQsWithFilterAPI = "/faqs";
export const getEthicalAdvicesAPI = "/ethical-advices";
